(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ma-contact"]) return;
  try {
    
  const messageField=document.getElementById('ma-message');
  const productQuery=new URLSearchParams(window.location.search).get('product');
  if(messageField&&productQuery&&!messageField.value.trim())messageField.value=productQuery;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matbakh-inox-sales"] && !Shopify.designMode) return;
  try {
    
function initInoxSales(root){
  if(root.dataset.ready)return;
  root.dataset.ready='1';
  if(root.dataset.previewThemeId){const preview=new URL(location.href);preview.searchParams.set('preview_theme_id',root.dataset.previewThemeId);history.replaceState({},'',preview);}
  const sizes=[...root.querySelectorAll('[data-ix-size]')];
  const buy=root.querySelector('[data-ix-buy]');
  if(!buy||!sizes.length)return;
  const sticky=root.querySelector('[data-ix-sticky]');
  const variant=new URL(location.href).searchParams.get('variant');
  let selected=sizes.find(b=>b.dataset.id===variant&&!b.disabled)||sizes.find(b=>b.getAttribute('aria-pressed')==='true')||sizes[0];
  let quantity=1;
  const money=n=>(Number(n)/100).toLocaleString('fr-FR',{maximumFractionDigits:2})+' DH';
  sizes.forEach(b=>b.querySelector('[data-ix-size-price]').textContent=money(b.dataset.price));
  function render(){
    sizes.forEach(b=>{b.classList.toggle('is-selected',b===selected);b.setAttribute('aria-pressed',String(b===selected));});
    root.querySelectorAll('[data-ix-title]').forEach(e=>e.textContent=selected.dataset.title);
    root.querySelectorAll('[data-ix-total]').forEach(e=>e.textContent=money(Number(selected.dataset.price)*quantity));
    root.querySelector('[data-ix-unit]').textContent=money(selected.dataset.price);
    root.querySelector('[data-ix-qty]').textContent=quantity;
    root.querySelector('[data-ix-minus]').disabled=quantity===1;
    root.querySelector('[data-ix-plus]').disabled=quantity===20;
    Object.assign(buy.dataset,{id:selected.dataset.id,title:root.dataset.productTitle+' — '+selected.dataset.title,price:selected.dataset.price,quantity:String(quantity)});
    buy.disabled=sticky.disabled=selected.dataset.available!=='true';
  }
  sizes.forEach(b=>b.addEventListener('click',()=>{selected=b;render();const url=new URL(location.href);url.searchParams.set('variant',b.dataset.id);history.replaceState({},'',url);}));
  root.querySelector('[data-ix-minus]').addEventListener('click',()=>{quantity=Math.max(1,quantity-1);render();});
  root.querySelector('[data-ix-plus]').addEventListener('click',()=>{quantity=Math.min(20,quantity+1);render();});
  function order(){if(buy.disabled)return;const error=root.querySelector('[data-ix-error]');if(typeof window.MA_ORDER_ADD==='function'){error.hidden=true;window.MA_ORDER_ADD(buy,true);}else{error.hidden=false;error.scrollIntoView({block:'center'});}}
  buy.addEventListener('click',order);sticky.addEventListener('click',order);render();
}
document.querySelectorAll('[data-inox-sales]').forEach(initInoxSales);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-inox-sales]').forEach(initInoxSales));

  } catch(e) { console.error(e); }
})();
})();
